import * as React from 'react';
import { Tooltip } from "../Global/Tooltip";
import lifecyclered from "src/assets/images/lifecycle-red.png";
import lifecyclegreen from "src/assets/images/lifecycle-green.png";
import lifecycleyellow from "src/assets/images/lifecycle-yellow.png";
import lifecycleUnknown from "src/assets/images/lifecycle-unknown.png";
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';

const DisplayLifeCycleRisk = (props) => {
    const { single_product, compare, isFrom } = props;
    const { LifeCycleRisk: { LOW, MED, HIGH } } = Constants;
    const { translation:t } = System;

    return (
        <>
            {single_product?.LifeCycleRisk !== undefined &&
                <>
                    {single_product.LifeCycleRisk === LOW &&
                        <Tooltip position={compare ? 'bottom left' : 'right center'}
                            opener={() => (
                                <span className={"datasheet " + (isFrom === Constants.systemModules.BOM ? '' : "d-inline-flex w-100")}>
                                    <span className="lifecycle low-risk cursor-default"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-html="true"
                                        data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs.">
                                        <img src={lifecyclegreen} className="lifecycle-icon-green"/>
                                        <span className="txt">{t('lifecycle')}</span>
                                    </span>
                                </span>
                            )}
                            content={() => (
                                <>
                                    {t('lowRiskContent')}
                                </>
                            )}
                        />
                    }
                    {single_product.LifeCycleRisk === MED &&
                        <Tooltip
                            position={compare ? 'bottom left' : 'right center'}
                            opener={() => (
                                <span className={"datasheet" + (isFrom === Constants.systemModules.BOM ? '' : " d-inline-flex w-100")}>
                                    <span className="lifecycle low-risk cursor-default"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-html="true"
                                        data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."                                    >
                                        <img src={lifecycleyellow} className="lifecycle-icon-yellow" />
                                        <span className="txt">{t('lifecycle')}</span>
                                    </span>
                                </span>
                            )}
                            content={() => (
                                <>
                                    {t('mediumRiskContent')}
                                </>
                            )}
                        />
                    }
                    {single_product.LifeCycleRisk === HIGH &&
                        <Tooltip
                            position={compare ? 'bottom left' : 'right center'}
                            opener={() => (
                                <span className={"datasheet" + (isFrom === Constants.systemModules.BOM ? '' : " d-inline-flex w-100")}>
                                    <span className="lifecycle low-risk  cursor-default"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-html="true"
                                        data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs.">
                                        <img src={lifecyclered} className="lifecycle-icon-red"/>
                                        <span className="txt">{t('lifecycle')}</span>
                                    </span>
                                </span>
                            )}
                            content={() => (
                                <>
                                    {t('highRiskContent')}
                                </>
                            )}
                        />
                    }
                    {single_product.LifeCycleRisk === null &&
                        <Tooltip position={compare ? 'bottom left' : 'right center'}
                            opener={() => (
                                <span className={"datasheet" + (isFrom === Constants.systemModules.BOM ? '' : " d-inline-flex w-100")}>
                                    <span className="lifecycle low-risk cursor-default"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-html="true"
                                        data-title="Unknown:<br/>Lifecycle information not available.">
                                        <img src={lifecycleUnknown} className="lifecycle-icon-yellow" />
                                        <span className="txt">{t('lifecycle')}</span>
                                    </span>
                                </span>
                            )}
                            content={() => (
                                <>
                                    {t('unknownRiskContent')}
                                </>
                            )}
                        />
                    }
                </>
            }
        </>
    );
}

export default DisplayLifeCycleRisk;